<template>
  <div>
    <div
      class="pj-ui-label"
      :class="[{ className }, { 'fs-3': isSelfService }]"
    >
      {{ dropdownLabel }}
    </div>
    <div class="pj-dropdown" :class="{ 'mt-4': isSelfService }">
      <vSelect
        v-model="selected"
        label="name"
        :options="options"
        @update:modelValue="handleSelectedValue"
        :placeholder="placeholder"
        :clearable="false"
        :disabled="disabled"
      ></vSelect>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, PropType, ref, watch, toRef } from "vue";
import vSelect from "vue-select";
import { IOptionDropdown } from "@/types/dropdown";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "Dropdown",
  emits: ["update:modelValue"],
  props: {
    options: {
      type: Array as PropType<IOptionDropdown[]>,
      required: true,
    },
    dropdownLabel: {
      type: String,
      default: "",
    },
    autocomplete: {
      type: String,
      default: "off",
    },
    placeholder: {
      type: String,
      default: "Select the option",
    },
    defaultValue: {
      type: Object,
      default: () => null,
    },
    className: {
      type: String,
      default: "",
    },
    isSelfService: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: Object as PropType<IOptionDropdown | null>,
      default: null,
    },
  },
  components: {
    vSelect,
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const selected = ref(props.modelValue ?? props.defaultValue);
    const handleSelectedValue = () => {
      emit("update:modelValue", selected.value);
    };

    watch(
      () => props.modelValue,
      (newVal) => {
        selected.value = newVal;
      }
    );

    return { t, handleSelectedValue, selected };
  },
});
</script>
<style lang="scss">
@import "@/assets/scss/_constants.scss";

.vs--searchable {
  padding: 16px;
  height: 56px;
  background: $pj-color-white;
  border: 2px solid $pj-color-silver-sand;
  border-radius: 8px;
  margin: 0px;
}

.pj-dropdown {
  margin-bottom: 10px;
}

.vs--open.vs--searchable {
  border-color: $pj-color-green;
}

.vs__selected-options .vs__search,
.vs__selected-options .vs__selected {
  color: $pj-color-gray-1;
  font-size: 16px;
  line-height: 20px;
  margin: 0;
  padding: 0;
}

.vs__selected-options {
  padding: 0;
}

.vs__dropdown-toggle {
  border: none;
  padding: 0;
}

.vs__dropdown-menu {
  border: 1px solid $pj-color-light-gray;
  border-radius: 0px 0px 8px 8px;
  box-shadow: none;
  padding: 0;
  margin: 0;
  margin-top: 3px;
}

.vs__dropdown-option {
  padding-left: 16px;
  height: 56px;
  border: 1px solid $pj-color-light-gray;
  line-height: 48px;
}

.vs__no-options {
  height: 56px;
  border: 1px solid $pj-color-light-gray;
  line-height: 48px;
}

.vs__dropdown-option--highlight {
  background-color: $pj-color-green;
}

.vs__open-indicator {
  fill: $pj-color-silver-sand;
  stroke: $pj-color-white;
}

.vs--open .vs__open-indicator {
  fill: $pj-color-green;
}

.self-onboarding-label-font-size {
  font-size: 18px !important;
}

.vs--disabled {
  border: none;
  background-color: $pj-color-light-silver;
}

.vs--disabled .vs__dropdown-toggle,
.vs--disabled .vs__clear,
.vs--disabled .vs__search,
.vs--disabled .vs__selected,
.vs--disabled .vs__open-indicator {
  background-color: $pj-color-light-silver;
}
</style>
